import { GenericDialog } from '@/components/shared/GenericDialog';
import { abyssColors } from '@/theme/colors';
import { Box, Button, Stack, Typography } from '@mui/material';
import {
  stageDialogStyles,
  DialogTitleStyle,
  DialogActionsStyle,
  DialogActionButtonStyle,
} from './styles';

type UserConfirmationDialogProps = {
  title: string
  description: string
  handleDialogOpen: boolean
  closeIcon: boolean
  handleDialogClose: () => void
  onContinue?: () => void
}
export const UserConfirmationDialog = ({ title, description, handleDialogOpen, handleDialogClose, closeIcon, onContinue }: UserConfirmationDialogProps) => {
  return (
    <GenericDialog
      open={handleDialogOpen}
      dialogStyles={stageDialogStyles}
      paperStyles={{ maxWidth: '52.6rem' }}
      titleStyles={DialogTitleStyle}
      onClose={handleDialogClose}
      title={title}
      showCloseIcon={closeIcon}
      content={
        <Box gap="1.6rem">
          <Typography
            fontSize="1.4rem"
            color={abyssColors.primary[700]}
            lineHeight={1.43}
            letterSpacing="normal"
          >
            {description}
          </Typography>
        </Box>
      }
      actions={
        <Stack
          gap="1.15rem"
          direction="row"
          sx={DialogActionButtonStyle}
        >
          <Button
            variant="outlined"
            color="primary"
            onClick={handleDialogClose}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={onContinue}
          >
            Continue
          </Button>
        </Stack>
      }
      actionsStyles={DialogActionsStyle}
    />
  );
}
